import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Card } from 'components/AntD';

export default function Option({ title, subtitle, item, hasPreview, isActive, disabled }) {
  return (
    <Card
      size="small"
      className={classNames('item-data-box', {
        active: isActive,
        disabled,
        'tw-text-bg-primary-100': disabled,
      })}
    >
      <div className="flex tw-pr-xs">
        <div className="tw-text-ellipsis tw-overflow-hidden">{title}</div>
        <div className="tw-text-ellipsis tw-overflow-hidden tw-text-sm">{subtitle}</div>
      </div>
      {hasPreview && (
        <div className="action">
          <a
            target="_blank"
            rel="noreferrer"
            title="Preview"
            className="action-item"
            href={item.link}
          >
            <i className="far fa-eye" />
          </a>
        </div>
      )}
    </Card>
  );
}

Option.propTypes = {
  item: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  hasPreview: PropTypes.bool,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
};
